export default {
  data() {
    return {
      defaultClass: undefined,
    }
  },
  mounted() {
    [this.defaultClass] = this.$el.classList
  },
}



// WEBPACK FOOTER //
// ./src/js/util/mixins/defaultClass.js